/*!
 * root.js
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}
